<template>
  <v-popover :auto-hide="true">
    <button @click="getData()"
            class="btn btn-xs btn-default"
    ><i class="icon-fa icon-fa-exchange"/>
    </button>
    <template slot="popover">
      <template v-if="loading">
        loading...
      </template>
      <template v-else>
        <div class="card mb-1" v-for="r in statData">
          <div class="card-body p-1">
            <p>{{ printDate(r.supplier_record.created_at, 'DD.MM.YYYY') }}</p>
            <template v-if="+r.supplier_record.data?.error === 404">
              <p>Препарат не найден на сайте</p>
            </template>
            <template v-else>
              <template v-if="+(r.supplier_record.data?.in_stores ?? 0) === 0">
                <p>нет в аптеках</p>
              </template>
              <template>
                <p>ц: <strong>{{ r.supplier_record.data?.min_price ?? 0 }}</strong>
                  <span v-if="r.supplier_record.data?.average_price">Ø <strong>{{
                      r.supplier_record.data.average_price ?? 0
                    }}</strong></span>
                  <span>a: <strong>{{ r.supplier_record.data.in_stores ?? 0 }}</strong></span>
                  <span>(с/в: <strong>{{
                      r.supplier_record.data?.pickup_shop ?? 0
                    }}/{{ r.supplier_record.data?.pickup_shop_later ?? 0 }}</strong>)</span>
                </p>
              </template>
            </template>
          </div>
        </div>
      </template>
    </template>
  </v-popover>
</template>

<script>
import api from "@/api";

export default {
  props: ['drugId', 'detailId'],
  data() {
    return {
      loading: false,
      statData: null,
    }
  },
  methods: {
    async getData() {
      if (this.statData) return;
      this.loading = true;
      const {data} = await api.index('/new/drugs/details/uteka-history?drug_id=' + this.drugId + '&detail_id=' + this.detailId);
      if (data.success) {
        this.statData = data.records;
      } else {
        toastr['warning'](data.message ?? 'ошибка сервера', 'Неуспешно')
      }
      this.loading = false;
    }
  }
}
</script>
